// כל מחרוזות המסך — קובץ אחד (11 §6).
export const T = {
  brand: 'aibify',
  nav: { artifacts: 'יצירות', ai2: 'אייבי', ai1: 'מנהל בינה', users: 'משתמשים' },
  roles: { admin: 'מנהל', creator: 'יוצר', member: 'משתמש' } as Record<string, string>,
  logout: 'יציאה',
  /** web-ai-disclaimer: שורה קבועה בתחתית כל מסך (Disclaimer.tsx) */
  disclaimer: 'בינה מלאכותית יכולה לטעות. השימוש בנתונים על אחריותך הבלעדית.',
  shell: {
    mainNav: 'ניווט ראשי',
    menu: 'תפריט',
    closeMenu: 'סגירת התפריט',
    consents: 'אישורים ממתינים',
    /** תווית קצרה בפס הניווט (השם המלא ב-aria-label) */
    consentsShort: 'אישורים',
    consentsCount: (n: number) => `אישורים ממתינים: ${n}`,
    skip: 'דילוג לתוכן',
    home: 'aibify: לדף היצירות',
  },
  login: {
    title: 'כניסה ל-aibify',
    /** כותרת הלשונית: "כניסה · <שם הסביבה>" */
    page: 'כניסה',
    email: 'אימייל',
    password: 'סיסמה',
    submit: 'כניסה',
    busy: 'מתחבר…',
    missing: 'יש למלא דוא"ל וסיסמה.',
    expired: 'פג תוקף ההתחברות. יש להיכנס מחדש.',
    /** web-visual-identity: אותו נוסח כמו באתר התדמיתי; הכותרת בשתי שורות (text-wrap: balance) */
    headline: ['אייבי, מנוע הבינה', 'שמכיר ומבין את העסק שלכם'],
    lead: 'דבר אל הנתונים והתהליכים העסקיים ותן לבינה להאזין לדופק ולראות צעד אחד קדימה בעסק',
    /** 26 §1.2: כישלון קישור כניסה — בלי לרמוז אם המשתמש קיים */
    linkExpired: 'הקישור פג או כבר שימש. אפשר להיכנס עם סיסמה או לבקש קישור חדש.',
    linkBusy: 'נכנס עם הקישור…',
    /** web-session-across-windows: הסשן פקע בשרת (7 ימים בלי פעילות / 30 סך הכול) */
    sessionExpired: 'הכניסה פגה אחרי שבוע בלי פעילות. היכנס שוב.',
    /** platform-password-recovery: קישור מתחת לכפתור הכניסה */
    forgot: 'שכחתי סיסמה',
  },
  /** platform-mfa-totp: אפליקציית אימות (TOTP) — מסך הקוד בכניסה, ההצטרפות, הבאנר בחסד, ההגדרות, המדיניות והאיפוס */
  /** universe-drawers-context: "מה המערכת יודעת על העסק" (/knowledge) — קריאה בלבד, מסונן לצופה. */
  knowledge: {
    nav: 'מה המערכת יודעת',
    page: 'מה המערכת יודעת על העסק',
    lead: 'הידע שאנשים בארגון אישרו, לפי מגירות. רק מה שמותר לך לראות. כדי לשנות פריט, בקש מאייבי.',
    search: 'חיפוש בידע',
    empty: 'עוד אין ידע שמור',
    emptyLead: 'כשמישהו מורשה מאשר כלל או הסבר בשיחה עם אייבי, הוא יופיע כאן.',
    noMatch: 'לא נמצא ידע שמתאים לחיפוש',
    unknown: 'לא ידוע',
    said: (who: string, when: string) => `אמר: ${who}, ${when}`,
    approved: (who: string) => `אישר: ${who}`,
    usedIn: (what: string) => `בשימוש ב${what}`,
  },
  mfa: {
    nav: 'אפליקציית אימות',
    page: 'אפליקציית אימות',
    code: {
      title: 'קוד מאפליקציית האימות',
      lead: 'פתח את אפליקציית האימות בטלפון והקלד את הקוד בן 6 הספרות.',
      label: 'קוד בן 6 ספרות',
      busy: 'בודק…',
      wrong: 'הקוד שגוי או שפג תוקפו. נסה את הקוד הנוכחי באפליקציה.',
      rate: 'יותר מדי ניסיונות. המתן דקה ונסה שוב.',
      failed: 'האימות לא הצליח כרגע. נסה שוב בעוד רגע.',
      lost: 'אין גישה לאפליקציה? פנה למנהל המערכת לאיפוס.',
      logout: 'יציאה',
    },
    enroll: {
      title: 'הפעלת אפליקציית אימות',
      titleRequired: 'נדרש להפעיל אפליקציית אימות',
      lead: 'שכבת הגנה נוספת לחשבון: בכל כניסה, אחרי הסיסמה, תקליד קוד מאפליקציה בטלפון (Google Authenticator, Microsoft Authenticator, 1Password וכדומה).',
      leadRequired: 'מנהל המערכת קבע שכל משתמש חייב אפליקציית אימות. כדי להמשיך להשתמש במערכת יש להפעיל אותה עכשיו.',
      leadGrace: (d: string) => `מנהל המערכת קבע שכל משתמש חייב אפליקציית אימות. אפשר להפעיל עכשיו, או לדחות עד ${d}.`,
      start: 'הפעל אפליקציית אימות',
      replace: 'החלפת מכשיר',
      later: 'אחר כך',
      step1: 'סרוק את הקוד באפליקציית האימות',
      manual: 'או הקלד את המפתח ידנית:',
      step2: 'הקלד את הקוד שהאפליקציה מציגה',
      done: 'אפליקציית האימות הופעלה.',
      doneLead: 'מעכשיו בכל כניסה תתבקש להקליד קוד מהאפליקציה.',
      recoveryTitle: 'חשוב לשמור',
      recovery: ['אם תחליף טלפון, היכנס קודם ולחץ "החלפת מכשיר" במסך הזה.', 'אם איבדת את הטלפון ואין גישה לאפליקציה, מנהל המערכת יכול לאפס לך את אפליקציית האימות, ואז תפעיל אותה מחדש.'],
      continue: 'המשך',
      startFailed: 'לא ניתן להתחיל את ההפעלה כרגע. נסה שוב בעוד רגע.',
      disabled: 'הפעלת אפליקציית אימות אינה זמינה במערכת הזו.',
      needCode: 'כדי להחליף מכשיר, הקלד קודם קוד מהמכשיר הנוכחי.',
    },
    banner: (d: string) => `מנהל המערכת דורש אפליקציית אימות. יש להפעיל עד ${d}.`,
    bannerAct: 'הפעלה',
    settings: {
      on: 'אפליקציית אימות פעילה',
      onLead: 'בכל כניסה תתבקש להקליד קוד מהאפליקציה בטלפון.',
      off: 'אפליקציית אימות לא פעילה',
      offLead: 'מומלץ להפעיל: גם מי שיודע את הסיסמה לא ייכנס בלי הטלפון שלך.',
    },
    policy: {
      title: 'אפליקציית אימות לכל המשתמשים',
      lead: 'כשהחובה פעילה, כל משתמש בלי אפליקציית אימות מתבקש להפעיל אותה בכניסה הבאה. בימי החסד אפשר לדחות; אחריהם הכניסה חסומה עד ההפעלה.',
      required: 'חובה לכל המשתמשים',
      graceDays: 'ימי חסד',
      since: (d: string) => `החובה פעילה מ-${d}`,
      save: 'שמירה',
      saved: 'נשמר ✓',
      appliesToYou: 'החובה חלה גם עליך.',
    },
    reset: {
      section: 'אפליקציית אימות',
      enrolled: 'פעילה',
      notEnrolled: 'לא פעילה',
      button: 'איפוס אפליקציית אימות',
      confirm: (n: string) => `לאפס ${/^[\u0590-\u05ff]/.test(n) ? `ל${n}` : `ל-${n}`} את אפליקציית האימות? בכניסה הבאה ייכנס עם הסיסמה בלבד ויתבקש להפעיל מחדש. לעשות זאת רק אם ביקש ואתה בטוח שזה הוא.`,
      done: 'אופסה. בכניסה הבאה יפעיל מחדש.',
      hint: 'לאיפוס כשאיבד את הטלפון. נרשם ביומן.',
    },
  },
  /** platform-password-recovery: /login/forgot — תשובה קבועה, בלי תלות בקיום המשתמש */
  forgot: {
    title: 'שכחתי סיסמה',
    lead: 'הקלד את כתובת הדוא"ל שאיתה נרשמת. אם היא רשומה, נשלח אליה מייל עם קישור לקביעת סיסמה חדשה.',
    submit: 'שלח קישור',
    busy: 'שולח…',
    missing: 'יש למלא כתובת דוא"ל.',
    sentTitle: 'בדוק את תיבת הדוא"ל',
    sent: 'אם הכתובת רשומה, נשלח אליה מייל עם קישור לקביעת סיסמה חדשה. הקישור תקף 60 דקות.',
    sentHint: 'אם המייל לא הגיע תוך כמה דקות, בדוק את תיקיית הספאם או פנה למנהל המערכת.',
    rateLimited: 'נשלח לפני רגע. אפשר לנסות שוב בעוד דקה.',
    back: 'חזרה לכניסה',
  },
  /** platform-password-recovery: /login/reset#t= — סיסמה חדשה ×2, verify רק בשליחה */
  reset: {
    title: 'קביעת סיסמה חדשה',
    lead: 'בחר סיסמה חדשה, לפחות 8 תווים.',
    password: 'סיסמה חדשה',
    confirm: 'אימות הסיסמה',
    submit: 'קביעת סיסמה וכניסה',
    busy: 'שומר…',
    tooShort: 'הסיסמה צריכה להיות לפחות 8 תווים.',
    mismatch: 'שתי הסיסמאות אינן זהות.',
    rejected: 'הסיסמה לא התקבלה: לפחות 8 תווים, ולא סיסמה נפוצה מדי. נסה סיסמה אחרת.',
  },
  sessionExpired: 'פג תוקף ההתחברות',
  network: 'אין חיבור לשרת. בדוק את הרשת ונסה שוב.',
  serverError: (s: number) => `תקלה בשרת (${s}). נסה שוב בעוד רגע.`,
  /** גלולת החיבור (ConnectionPill, lib/health.ts): כותרת + שורת המשך; long = אחרי 2 דק' */
  health: {
    updating: { title: 'מעדכנים את המערכת', sub: 'חוזרים בעוד רגע' },
    updatingLong: { title: 'העדכון לוקח קצת יותר מהרגיל', sub: 'מה שכתבתם שמור. נמשיך מכאן לבד, אין צורך לרענן.' },
    offline: { title: 'אין חיבור לאינטרנט', sub: 'נמשיך מאיפה שעצרנו' },
    offlineLong: { title: 'עדיין אין חיבור לאינטרנט', sub: 'מה שכתבתם שמור. נמשיך ברגע שהרשת תחזור.' },
    error: { title: 'השרת לא עונה כרגע', sub: 'ממשיכים לנסות ברקע' },
    errorLong: { title: 'השרת עדיין לא עונה', sub: 'מה שכתבתם שמור. אם זה נמשך, כדאי לפנות לתמיכה.' },
    back: 'חזרנו',
  },
  updatingError: 'המערכת מתעדכנת. נסה שוב בעוד רגע.',
  badResponse: 'תשובה לא צפויה מהשרת.',
  loading: 'טוען…',
  retry: 'נסה שוב',
  renderError: 'משהו השתבש בהצגת המסך.',
  refresh: 'רענן',
  artifacts: {
    title: 'יצירות',
    search: 'חיפוש יצירה',
    allTypes: 'כל הסוגים',
    allCreators: 'כל היוצרים',
    empty: 'אין יצירות שתואמות לחיפוש.',
    none: 'עדיין אין יצירות.',
    by: (n: string) => `מאת ${n}`,
    subtitle: 'דוחות, תצוגות ותהליכים שנבנו על הנתונים של הארגון.',
    count: (n: number, all: number) => (n === all ? `${all} יצירות` : `${n} מתוך ${all} יצירות`),
    clear: 'ניקוי סינון',
    open: 'פתיחה',
    // web-artifacts-rows-and-versions: טבלת שורות — כותרות עמודות, מיון
    col: { name: 'שם', kind: 'סוג', version: 'גרסה', asOf: 'נכון ל-', updated: 'עודכן', creator: 'יוצר', share: 'שיתוף', tags: 'תגים', open: 'פעולה' },
    sortBy: (col: string) => `מיון לפי ${col}`,
    draft: 'טיוטה',
    // 22: תג הסוג (sender/flow הוסרו — 0024)
    kinds: { report: 'דוח', chat: 'שיחה', app: 'אפליקציה' } as Record<string, string>,
    // artifacts-09-archive: תפריט הפעולות בדף היצירה (ליוצר); בארכיון לא מוצגת — שחזור דרך אייבי
    actions: 'פעולות',
    archive: 'העבר לארכיון',
    archiveConfirm: (name: string) => `להעביר את «${name}» לארכיון? היא תיעלם מכל הרשימות, גם ממי ששיתפת איתו, והתזמונים שלה יושהו. שום דבר לא נמחק.`,
    archiveYes: 'כן, להעביר לארכיון',
    archiving: 'מעביר…',
    cancel: 'ביטול',
    archived: 'הועבר לארכיון. אפשר לבקש מאייבי לשחזר',
    // artifacts-rename: שם ותיאור — בלי גרסה חדשה; הכתובת לא משתנה
    rename: 'שינוי שם ותיאור',
    renameName: 'שם',
    renameDescription: 'תיאור',
    renameHint: 'מתעדכן מיד בכל מקום. הקישור והתזמונים לא משתנים.',
    renameSave: 'שמירה',
    renaming: 'שומר…',
    renameEmpty: 'צריך שם',
    // artifacts-list-dates: מתי היצירה עצמה השתנתה (גרסה, פרסום, שם) ומתי נוצרה; לא "נכון ל-" של הנתונים
    updatedOn: (d: string) => `עודכן ${d}`,
    createdOn: (d: string) => `נוצר ${d}`,
    dismiss: 'סגירה',
  },
  // 22 + web-artifacts-rows-and-versions: שני צירי גרסה — "גרסה 4" (היצירה) ובנפרד "אפליקציה 1" (הסוג וגרסתו); שדרוג (תור מזורע), מפרט.
  // בנייה וקבצים לא מוצגים במסך — רק הודעה אחת ליוצר כשהבנייה נכשלה
  kinds: {
    /** "אפליקציה V1"; דוח/שיחה על גרסת סוג 1 בלי חדשה — שם הסוג בלבד (אין רעש) */
    label: (kindHe: string, v: number | null | undefined, showNumber: boolean) => (showNumber && v ? `${kindHe} V${v}` : kindHe),
    available: (base: string, latest: number) => `${base} → זמינה V${latest}`,
    upgrade: 'שדרג',
    upgradeAvailable: 'שדרוג זמין',
    upgradePrompt: (name: string, kind: string, from: number, to: number) => `שדרג את היצירה «${name}» מ-${kind} ${from} ל-${kind} ${to}`,
    /** 25 §1.5: שדרוג של רכיב מוכן בלבד — בלי שם פנימי ובלי גרסה */
    upgradePromptPlain: (name: string) => `שדרג את היצירה «${name}»: יש שיפורים זמינים`,
    opening: 'פותח שיחה עם אייבי…',
    tabSpec: 'מפרט',
    buildFailedShort: 'הגרסה האחרונה לא נבנתה. בקש מאייבי לתקן',
    kindChanged: 'שודרג',
  },
  // 09 §1.1: יצירה פרטית ליוצר; שיתוף מפורש = צפייה + הרצה בלבד
  share: {
    button: 'שיתוף',
    title: 'שיתוף',
    close: 'סגירה',
    private: 'פרטי',
    shared: 'משותף',
    sharedWithMe: (n: string) => `משותף איתי · ${n}`,
    explain: 'היצירה פרטית שלך. פרסום רק קובע איזו גרסה חיה, הוא לא משתף. מי שתשתף איתו יוכל לראות ולהריץ בלבד: לא לערוך, לא לראות קוד ולא לשנות ממשקים. גם מנהל רואה רק אם שיתפת איתו.',
    everyone: 'כל המשתמשים',
    everyoneHint: (role: string) => `כל משתמש פעיל עם הרשאה "${role}" ומעלה`,
    people: 'אנשים מסוימים',
    pick: 'בחירת משתמש',
    pickNone: 'בחרו משתמש…',
    add: 'הוספה',
    remove: (n: string) => `הסרת ${n}`,
    none: 'עדיין לא שיתפת עם אף אחד.',
    notPublished: 'ליצירה אין עדיין גרסה מפורסמת. מי ששיתפת יראה אותה רק אחרי הפרסום.',
    confirmShare: (who: string, name: string) => `בשמירה: ${who} יוכלו לראות ולהריץ את «${name}», לא לערוך.`,
    confirmPrivate: (name: string) => `בשמירה: «${name}» תהיה פרטית: רק את/ה רואה אותה.`,
    save: 'שמירה',
    saving: 'שומר…',
    saved: 'נשמר ✓',
    /** users-delegation: שיתוף הלאה — מי שיתף (לא היוצר). */
    sharedByOther: (n: string) => `שיתף: ${n}`,
  },
  /** users-delegation: מסך "משתמשים" (admin ובעל הרשאת האצלה). */
  users: {
    title: 'משתמשים',
    subtitle: 'הוספת משתמשים וניהול ההרשאות שלהם.',
    subtitleDelegate: 'יש לך הרשאת האצלה: אפשר להוסיף משתמשים ולתת להם עד ההרשאות שלך.',
    tabUsers: 'משתמשים',
    tabLog: 'יומן',
    /** platform-mfa-totp: לשונית "אבטחה" (admin) — מדיניות אפליקציית האימות */
    tabSecurity: 'אבטחה',
    search: 'חיפוש לפי שם או מייל',
    count: (n: number, all: number) => (n === all ? `${all} משתמשים` : `${n} מתוך ${all}`),
    add: 'הוספת משתמש',
    col: { name: 'שם', role: 'תפקיד', status: 'מצב', createdBy: 'נוצר על ידי', delegation: 'האצלה' },
    roles: { admin: 'מנהל מערכת', creator: 'יוצר', member: 'משתמש רגיל' } as Record<string, string>,
    active: 'פעיל',
    disabled: 'מושבת',
    delegate: 'האצלה',
    readOnly: 'מנהל מערכת: אין פעולות',
    empty: 'אין משתמשים שתואמים לחיפוש.',
    form: { email: 'מייל', name: 'שם', role: 'תפקיד', submit: 'הוספה', cancel: 'ביטול', busy: 'מוסיף…' },
    created: (n: string) => `${n} נוסף/ה.`,
    secretTitle: 'סיסמה זמנית (מוצגת פעם אחת)',
    secretHint: 'עדיף לשלוח קישור כניסה במקום להעביר סיסמה.',
    copy: 'העתקה',
    copied: 'הועתק ✓',
    close: 'סגירה',
    sections: { role: 'תפקיד', status: 'מצב', perms: 'הרשאות', web: 'גישה לאינטרנט', link: 'קישור כניסה', share: 'שיתוף יצירה', delegation: 'הרשאת האצלה' },
    deactivate: 'השבתה',
    reactivate: 'הפעלה מחדש',
    noPerm: 'אין לך הרשאה זו',
    webNone: 'אין גישה פעילה לאינטרנט.',
    webHosts: 'אתרים (מופרדים בפסיק)',
    webUntil: 'עד תאריך',
    webAdd: 'מתן גישה',
    webUntilMax: (d: string) => `עד ${d} לכל היותר (התוקף של הגישה שלך)`,
    webAll: 'כל האינטרנט',
    remove: (n: string) => `הסרת ${n}`,
    until: (d: string) => `עד ${d}`,
    linkMake: 'יצירת קישור כניסה',
    linkHint: 'קישור אישי, לשימוש פעם אחת, תקף שעה. מוצג פעם אחת.',
    shareNone: 'לא שותפו יצירות עם המשתמש.',
    sharePick: 'בחירת יצירה',
    sharePickNone: 'בחרו יצירה…',
    shareAdd: 'שיתוף',
    sharedBy: (n: string) => `שיתף: ${n}`,
    delegationOn: 'יש הרשאת האצלה',
    delegationHint: (n: string) => `${n} יוכל/תוכל להוסיף משתמשים ולתת להם עד ההרשאות שלו/ה. הסרה לא משנה את מה שכבר נתן/ה.`,
    selfNote: 'את החשבון הזה אי אפשר לשנות מכאן.',
    log: { empty: 'אין עדיין שינויים ביומן.', mine: 'הפעולות שלך.', all: 'כל השינויים במשתמשים: מי, מה, מתי ודרך מה.' },
    // data-access-rls: "גישה לנתונים" במגירה
    /** data-access-rls §7, §7.1: בלי ז'רגון ובלי מילים של תחום. השמות העסקיים מגיעים מהעץ של המופע דרך ה-API. */
    da: {
      title: 'מה הוא רואה',
      adminNote: 'מנהל מערכת רואה תמיד את כל הנתונים',
      delegateNote: 'אפשר לתת רק נתונים שאתה עצמך רואה.',
      now: 'עכשיו הוא רואה',
      change: 'שינוי',
      ask: (n: string) => `מה ${n} יראה?`,
      all: 'רואה הכול',
      allSub: 'כל הנתונים, בלי הגבלה',
      some: 'רק חלק',
      someSub: 'לבחור מה הוא יראה',
      copyFrom: 'כמו של…',
      pickTitle: 'מה מתוך זה?',
      pickHint: (ents: string) => `קובע מה יראה ב${ents}. אפשר לבחור יותר מאחד.`,
      pickSearch: 'חיפוש לפי שם',
      pickNone: 'לא נמצא',
      pickEmpty: (ents: string) => `לא נבחר כלום: לא יראה ${ents}`,
      nPicked: (n: number) => (n === 1 ? 'נבחר אחד' : `נבחרו ${n}`),
      truncated: 'מוצגים 300 הנפוצים. לאחר, חפשו.',
      rowsOf: (n: number, ent: string) => `${n.toLocaleString('he-IL')} ${ent}`,
      more: 'להסתיר עוד (לא חובה)',
      kindHidden: 'לא יראה בכלל',
      fieldsHidden: 'פרטים שלא יראה',
      next: 'המשך',
      back: 'חזרה',
      cancel: 'ביטול',
      confirmTitle: (n: string) => `בשמירה ${n} יראה:`,
      rowsAll: 'הכול',
      rowsNone: 'לא רואה',
      save: 'שמור',
      saving: 'שומר…',
      savedNow: (n: string) => `נשמר. מעכשיו ${n} רואה:`,
      detail: 'פירוט',
      detailHide: 'הסתרה',
      spreads: 'סיכומים מוכנים',
      spreadOk: 'זמין',
      spreadBlocked: 'לא זמין לו',
      history: 'מי שינה מה ומתי',
      historyNone: 'עוד לא שינו כלום.',
      historyMore: (n: number) => `עוד ${n}`,
      undo: 'בטל שינוי',
      undoing: 'מבטל…',
      banner: 'מוצגים רק הנתונים שהוקצו לך',
    },
  },
  artifact: {
    tabRun: 'הרצה',
    tabRuns: 'ריצות',
    tabVersions: 'גרסאות',
    params: 'פרמטרים',
    run: 'הרצה',
    running: 'מריץ…',
    changeParams: 'שינוי פרמטרים',
    cancel: 'עצירה',
    status: {
      queued: 'בתור',
      running: 'רץ',
      waiting_consent: 'ממתין לאישור',
      done: 'הסתיים',
      failed: 'נכשל',
      timeout: 'חרג מזמן',
      canceled: 'בוטל',
    } as Record<string, string>,
    noRuns: 'אין ריצות עדיין.',
    version: (v: number) => `גרסה ${v}`,
    openRun: 'פתיחה',
    runBy: (n: string) => `הורץ על ידי ${n}`,
    log: 'יומן ריצה',
    back: 'חזרה ליצירה',
    failed: 'הריצה נכשלה',
    readyTitle: 'מוכן להרצה',
    readyHint: 'בחרו פרמטרים ולחצו "הרצה". התוצאה תופיע כאן.',
    current: 'נוכחית',
    // artifacts-report-cache (report@2): דוח נפתח מהחישוב האחרון
    computedAgo: (ago: string) => `חושב ${ago}`,
    recompute: 'חשב מחדש',
    recomputing: 'מחשב מחדש…',
    noNewData: 'אין נתונים חדשים מאז',
    externalOnly: 'דוח עם פעולה חיצונית מחושב רק בבקשה',
    // artifacts-draft-preview: היוצר מנסה גרסה שלא פורסמה במסך היצירה
    draftBanner: (v: number) => `טיוטה · גרסה ${v}, לא חיה`,
    oldBanner: (v: number) => `גרסה ${v}, לא חיה`,
    draftHint: (live: number | null) => (live == null ? 'היצירה עוד לא פורסמה. מה שמריצים כאן לא משנה דבר עד הפרסום.' : `הגרסה החיה היא ${live}, ומי שמשותף ביצירה ממשיך לראות אותה עד הפרסום.`),
    publish: 'פרסם',
    publishConfirm: (v: number, live: number | null) => (live == null ? `לפרסם את גרסה ${v}? היא תהיה הגרסה החיה. פרסום לא משתף את היצירה עם איש.` : `לפרסם את גרסה ${v}? היא תחליף את גרסה ${live} החיה, גם אצל מי שמשותף ביצירה.`),
    publishYes: 'כן, פרסם',
    publishNo: 'ביטול',
    published: (v: number) => `גרסה ${v} פורסמה והיא עכשיו החיה`,
    backToLive: 'לגרסה החיה',
    tryDraft: 'לנסות',
    draft: 'טיוטה',
  },
  ask: {
    title: 'שאל',
    titlePage: 'שאלה על הנתונים',
    hint: 'שאלה בעברית, והתשובה מתוך אותם נתונים, עם "נכון ל-".',
    label: 'שאלה',
    placeholder: 'למשל: מי הסוכן הכי חזק השנה?',
    submit: 'שאל',
    busy: 'עונה…',
    thinking: 'מחפש תשובה בנתונים…',
    openAi2: 'פתח באייבי',
    empty: 'לא התקבלה תשובה.',
  },
  form: {
    required: 'שדה חובה',
    number: 'יש להזין מספר',
    integer: 'יש להזין מספר שלם',
    min: (n: number) => `לפחות ${n}`,
    max: (n: number) => `לכל היותר ${n}`,
    date: 'תאריך לא תקין',
    range: 'תאריך ההתחלה אחרי תאריך הסיום',
    from: 'מתאריך',
    to: 'עד תאריך',
    choose: 'בחירה…',
    unsupported: 'סוג פרמטר שאינו נתמך במסך',
    invalidLen: (min?: number, max?: number) => (min !== undefined ? `לפחות ${min} תווים` : `לכל היותר ${max} תווים`),
    // artifacts-report-lookup (report@3): שדה בחירה עם חיפוש
    pick: 'בחר מהרשימה',
    searching: 'מחפש…',
    noResults: 'אין תוצאות',
    moreResults: 'יש עוד, דייק את החיפוש',
    tooManySearches: 'יותר מדי חיפושים, נסה עוד רגע',
    searchPlaceholder: 'הקלד חלק מהשם או המספר',
  },
  ai: {
    title1: 'מנהל בינה',
    title2: 'אייבי',
    conversations: 'שיחות',
    newConversation: 'שיחה חדשה',
    noConversations: 'אין שיחות עדיין.',
    untitled: 'שיחה ללא כותרת',
    searchConversations: 'חיפוש בשיחות',
    noSearchResults: 'לא נמצאו שיחות.',
    placeholder1: 'מה לבדוק, לחבר או להגדיר?',
    placeholder2: 'מה תרצה לדעת מהנתונים?',
    emptyTitle: 'במה נתחיל?',
    starters1: ['מה מצב החיבורים?', 'מה ממתין לאישור?', 'אילו נתונים מסונכרנים?'],
    starters2: ['מכירות החודש מול אשתקד', 'מי חייב לנו הכי הרבה', 'מה חסר במלאי', 'הזמנות שלא הגיעו'],
    send: 'שליחה',
    stop: 'עצירה',
    stopping: 'עוצר, ממתין לאישור השרת…',
    you: 'את/ה',
    agent: (level: 1 | 2) => (level === 1 ? 'מנהל בינה' : 'אייבי'),
    thinking: 'עובד…',
    /** 11 (2026-10-16) שורת העבודה של התור החי: ה-summaryHe של הכלי האחרון, או אלה */
    live: { thinking: 'חושב…', stopping: 'עוצר…' },
    /** הקיפול אחרי done: "8 צעדים" — פותח את רשימת הכלים */
    steps: (n: number) => (n === 1 ? 'צעד אחד' : `${n} צעדים`),
    /** צעדים שנכשלו (tool_result ok=false) — בסיכום, כדי שלא ייבלעו בקיפול: "8 צעדים · 1 נכשל" */
    stepsFailed: (n: number) => `${n} נכשל${n === 1 ? '' : 'ו'}`,
    /** 10 §1 הודעה באמצע תור: השדה פתוח גם בזמן שהסוכן עובד */
    placeholderLive: 'אפשר לכתוב גם עכשיו…',
    midTurn: 'נשלח באמצע',
    heard: 'התקבל',
    queuedSend: 'תישלח כשהתור הנוכחי יסתיים',
    /** הודעה שנשלחה מהמסך ועוד לא אושרה בשרת (בועה אופטימית) — לעולם לא נעלמת בשקט */
    out: {
      sending: 'שולח…',
      uploading: (pct: number) => `מעלה קבצים… ${pct}%`,
      retrying: 'אין חיבור לשרת. מנסה שוב…',
      failed: 'לא נשלחה',
      resend: 'שליחה שוב',
      edit: 'עריכה',
      cancel: 'ביטול',
    },
    /** הודעה באמצע תור שהסוכן לא קלט עד סוף התור */
    midFollowUp: 'תיענה בתור הבא',
    midNotHeard: 'לא הגיעה לסוכן',
    // קבצים מצורפים (10 §1)
    voice: {
      start: 'הקלטה קולית',
      stop: 'עצירת ההקלטה',
      hint: 'מדברים, ולוחצים שוב כדי לעצור. הטקסט ייכנס לשדה לעריכה, עד שתי דקות',
      recording: (t: string) => `מקליט ${t}`,
      transcribing: 'מתמלל…',
      denied: 'אין גישה למיקרופון. צריך לאשר מיקרופון בדפדפן',
      unsupported: 'הדפדפן הזה לא תומך בהקלטה',
      empty: 'לא נשמע דיבור בהקלטה',
      failed: 'התמלול נכשל. נסה שוב, או כתוב את ההודעה',
    },
    attach: {
      button: 'צירוף קובץ',
      hint: 'תמונה, PDF, Excel/CSV, Word, טקסט. עד 25MB לקובץ, עד 10 להודעה',
      remove: (name: string) => `הסרת ${name}`,
      dropHere: 'שחרר כדי לצרף לשיחה',
      uploading: (pct: number) => `מעלה… ${pct}%`,
      tooLarge: 'הקובץ גדול מ-25MB',
      tooMany: 'אפשר לצרף עד 10 קבצים להודעה',
      unsupported: (name: string) => `סוג הקובץ של "${name}" אינו נתמך`,
      canceled: 'ההעלאה בוטלה',
      download: (name: string) => `הורדת ${name}`,
      downloadFailed: 'ההורדה נכשלה. הקובץ כבר לא זמין',
      files: 'קבצים מצורפים',
      /** קובץ שהסוכן שלח (10 §1 chat.sendFile / קבצי ריצת ניסיון). */
      sent: 'קובץ מהסוכן',
      downloadBtn: 'הורדה',
      open: 'פתיחה',
      openLabel: (name: string) => `פתיחת ${name} בלשונית חדשה`,
      loading: 'טוען…',
      previewFailed: 'לא ניתן להציג. אפשר להוריד',
      size: (bytes: number) => (bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toLocaleString('he-IL', { maximumFractionDigits: 1 })} MB` : `${Math.max(1, Math.round(bytes / 1024)).toLocaleString('he-IL')} KB`),
    },
    canceled: 'התור נעצר.',
    timeout: 'התור חרג מהזמן.',
    errored: 'התור הסתיים בשגיאה.',
    toolRunning: 'רץ',
    toolOk: 'הסתיים',
    toolFail: 'נכשל',
    toolNoResult: 'בלי תוצאה',
    secretOnce: 'מוצג פעם אחת בלבד, לא נשמר',
    consentPending: 'ממתין לאישורך',
    consentOpen: 'פתיחת האישור',
    consentStatus: { pending: 'ממתין לאישור', approved: 'אושר', partial: 'אושר חלקית', rejected: 'נדחה', expired: 'פג תוקף' } as Record<string, string>,
    usage: (i: number, cached: number, o: number, agorot: number) =>
      `שימוש: ${i.toLocaleString('he-IL')} טוקנים נכנסים${cached ? ` (+${cached.toLocaleString('he-IL')} מהמטמון)` : ''} · ${o.toLocaleString('he-IL')} יוצאים · ${(agorot / 100).toLocaleString('he-IL', { style: 'currency', currency: 'ILS' })}`,
    // reconnecting/offline — הגלולה הכללית (ConnectionPill) אומרת את זה; כאן היה מהבהב בכל ניקוז
    stream: { connecting: 'מתחבר…', open: 'מחובר', reconnecting: '', offline: '', closed: '' } as Record<string, string>,
    cannotContinue: 'אי אפשר להמשיך את השיחה הזו.',
    toEnd: 'לסוף',
    nextSteps: 'להמשך',
    nextStepsHint: 'לחיצה שולחת את ההצעה כהודעה שלך',
    toEndLabel: 'גלילה לסוף השיחה',
    panel: 'פאנל',
    closePanel: 'סגירה',
    // web-ai-stage-layout: קיפול הרשימה והפאנל לפסים; הגדלה מתוך השיחה
    openConversations: 'פתיחת רשימת השיחות',
    openPanel: 'פתיחת הפאנל',
    newReply: 'תשובה חדשה · הצג',
    // פאנל בינה-2 (11 §1): לפי מה שהמשתמש בא בשבילו — בלי מונים שאינם ניתנים לפעולה
    ai2: {
      open: 'פתח',
      waiting: 'ממתין לך',
      consent: (title: string, n: number) => (n > 1 ? `ממתין לאישורך: ${title} · ${n.toLocaleString('he-IL')} פריטים` : `ממתין לאישורך: ${title}`),
      draft: (name: string) => `טיוטה שלא פורסמה: ${name}`,
      failed: (reason: string) => `נכשל: ${reason}`,
      built: 'מה בנינו בשיחה הזו',
      builtEmpty: 'עוד לא נבנה כלום בשיחה הזו.',
      builtNoConversation: 'מה שייבנה בשיחה יופיע כאן.',
      mine: 'היצירות שלי',
      mineEmpty: 'עוד אין לך יצירות. בקש מאייבי לבנות אחת.',
      spreads: 'פריסות',
      spread: 'פריסה',
      usesSpreads: 'פריסות',
      slow: (secs: number) => `איטית (${secs} שניות)`,
      // data-spreads-private: פריסה שרק המשתמש רואה
      private: 'פרטית',
      privateTitle: 'רק אתה רואה את הפריסה הזו. יצירה שתשתף תמשיך לקרוא אותה',
      lastRun: (status: string, at: string) => `${status} · ${at}`,
      noRun: 'עוד לא הורצה',
      status: { draft: 'טיוטה', published: 'פורסם', frozen: 'מוקפא', archived: 'בארכיון', active: 'פעיל' } as Record<string, string>,
      action: { create: 'נוצר', version: 'גרסה נשמרה', publish: 'פורסם', rollback: 'הוחזר לגרסה', freeze: 'הוקפא', unfreeze: 'שוחרר', fork: 'הועתק' } as Record<string, string>,
      data: 'הקשר נתונים',
      fresh: (at: string) => `נתונים עדכניים ל-${at}`,
      stale: (at: string) => `הנתונים לא התעדכנו מ-${at}`,
      staleUnknown: 'הנתונים לא מתעדכנים',
      syncFailed: (reason: string) => `סנכרון נכשל: ${reason}`,
      never: 'עוד לא סונכרן',
      toAdmin: 'למנהל בינה',
      askAdmin: 'רק מנהל יכול לתקן',
      noWorlds: 'אין עולמות פעילים.',
      // conversation-admin-requests: מה שאייבי העבירה למנהל בשם המשתמש
      requests: 'בקשות למנהל המערכת',
      requestStatus: { open: 'ממתין למנהל', in_progress: 'המנהל מטפל', done: 'טופל', declined: 'נדחה' } as Record<string, string>,
    },
    worlds: 'עולמות',
    systemAlerts: 'התראות מערכת',
    connector: { online: 'מחובר', disconnected: 'מנותק', none: 'ללא קונקטור' } as Record<string, string>,
    lastSeen: 'נראה לאחרונה',
    lastSync: 'סנכרון אחרון',
    syncRuns: 'ריצות סנכרון',
    users: 'משתמשים',
    /** 26: קישור כניסה חד-פעמי מהפאנל (admin) — מוצג פעם אחת */
    loginLink: {
      button: 'קישור כניסה',
      title: (name: string) => `קישור כניסה ל-${name}`,
      until: (hhmm: string) => `לשימוש פעם אחת, תקף עד ${hhmm}. קישור חדש מבטל את הקודם. הקישור מוצג רק עכשיו.`,
      copy: 'העתקה',
      copied: 'הועתק',
      close: 'סגירה',
      failed: 'יצירת הקישור נכשלה',
    },
    inactive: 'לא פעיל',
    proposals: 'הצעות ממתינות',
    noProposals: 'אין הצעות ממתינות.',
    proposalKind: { add_entities: 'הוספת ישויות', add_fields: 'הוספת שדות', declare_triad: 'הכרזת קוד/תיאור', declare_relation: 'הכרזת קשר', define: 'הגדרה', import_change: 'שינוי ייבוא' } as Record<string, string>,
    approve: 'אשר',
    reject: 'דחה',
    proposedBy: (n: string) => `הוצע על ידי ${n}`,
    proposalDetails: 'פרטים',
    proposalEvidence: 'ראיות',
    proposalNodes: 'צמתים',
    decided: { approved: 'ההצעה אושרה', rejected: 'ההצעה נדחתה' } as Record<string, string>,
    recentProposals: 'הצעות שהוכרעו לאחרונה',
    proposalState: { approved: 'אושרה', rejected: 'נדחתה', withdrawn: 'בוטלה', superseded: 'הוחלפה' } as Record<string, string>,
    consentsPending: (n: number) => `ממתינים לאישורך: ${n}`,
    // conversation-admin-requests: בקשות שאייבי העבירה מהמשתמשים
    requests: {
      title: 'בקשות משתמשים',
      inProgressTitle: 'בקשות בטיפול',
      handle: 'טפל בזה',
      decline: 'דחה',
      declineConfirm: 'דחה את הבקשה',
      cancel: 'ביטול',
      reason: 'סיבה (תוצג למבקש)',
      reasonRequired: 'כתוב סיבה כדי לדחות',
      need: 'מה צריך',
      findings: 'מה אייבי מצאה',
      by: (names: string) => `ביקשו: ${names}`,
      inProgress: 'בטיפול',
      ready: 'פורסם, ממתין לסגירה',
      readyHint: 'השינוי פורסם. מנהל הבינה צריך לסגור את הבקשה ולכתוב למבקש מה נעשה.',
      openConversation: 'לשיחת הטיפול',
      kind: { index: 'אינדקס', summary: 'סיכום מוכן', tree: 'עץ הנתונים', interface: 'ממשק', access: 'הרשאה', other: 'אחר' } as Record<string, string>,
    },
    attention: (n: number) => `${n} ממתינים לך`,
    sync: {
      ok: (ago: string) => `סנכרון תקין · ${ago}`,
      stale: (at: string) => `סנכרון תקוע מ-${at}`,
      staleUnknown: 'סנכרון תקוע',
      failed: (reason: string) => `נכשל: ${reason}`,
      running: 'סנכרון ראשון רץ…',
      never: 'עוד לא סונכרן',
      runs: 'ריצות אחרונות',
      noRuns: 'אין ריצות עדיין.',
      lastOk: 'סנכרון תקין אחרון',
      run: { ok: 'תקין', done: 'תקין', partial: 'חלקי', failed: 'נכשל', error: 'נכשל', running: 'רץ' } as Record<string, string>,
      tables: 'טבלאות',
      signal: { engine_log: 'לוג המנוע', engine_marker: 'סמן המנוע', update_column: 'עמודת עדכון', document_date: 'תאריך המסמך', none: 'סבב בלבד' } as Record<string, string>,
      asOf: 'נכון ל-',
      verifiedAt: 'אומת במלואו',
      notVerified: 'סבב מלא טרם הושלם',
      fallback: (to: string) => `נפל ל-${to}`,
      loading: (done: number, total: number) => `טעינה ראשונה ${done}/${total}`,
    },
    pairing: {
      title: (worlds: string) => `מנהל בינה מבקשת פרטי חיבור ל-${worlds}`,
      why: 'סיסמאות לא נכתבות בשיחה, כי השיחה נשמרת בהיסטוריה. מה שמוזן כאן עובר ישירות לשרת, מוצפן, ונמסר לקונקטור פעם אחת בצימוד.',
      expires: (at: string) => `הבקשה בתוקף עד ${at}`,
      connRef: 'שם החיבור (connRef)',
      driver: 'סוג מסד',
      mssql: 'SQL Server',
      oracle: 'Oracle',
      host: 'שרת',
      port: 'פורט',
      db: 'מסד נתונים',
      dbFor: (ref: string) => `מסד נתונים: ${ref}`,
      service: 'Service',
      // change connector-oracle-thick-mode: Thick כשמוגדר; נכתב ל-options.clientLibDir (לא סוד)
      clientLibDir: 'תיקיית Oracle Client על המארח (אופציונלי)',
      clientLibDirHint: 'רק אם המסד דורש Oracle Client (שגיאת NJS-116 בקונקטור). תיקיית ה-bin של ה-Client שכבר מותקן על מכונת הקונקטור.',
      user: 'משתמש',
      password: 'סיסמה',
      submit: 'שליחה לשרת',
      busy: 'שולח…',
      ok: (refs: string) => `פרטי החיבור נשמרו מוצפנים (${refs}). הקונקטור יקבל אותם כשיתחבר עם הקוד.`,
    },
  },
  consent: {
    title: 'אישור פעולה',
    listTitle: 'ממתינים לאישורך',
    none: 'אין פריטים שממתינים לאישור.',
    close: 'סגירה',
    items: (n: number) => `${n.toLocaleString('he-IL')} פריטים`,
    range: (a: number, b: number, n: number) => `פריטים ${a.toLocaleString('he-IL')}–${b.toLocaleString('he-IL')} מתוך ${n.toLocaleString('he-IL')}`,
    prev: 'הקודמים',
    next: 'הבאים',
    selected: (n: number) => `${n.toLocaleString('he-IL')} מסומנים`,
    selectPage: 'סימון כל העמוד',
    clear: 'ניקוי סימון',
    approveAll: 'אשר הכול',
    approveSelected: (n: number) => `אשר את המסומנים (${n.toLocaleString('he-IL')})`,
    rejectAll: 'דחה הכול',
    busy: 'שולח…',
    expires: 'בתוקף עד',
    requestedBy: 'ביקש/ה',
    preview: 'תצוגה',
    scopeTitle: 'בקשת גישה',
    scopeHosts: 'אתרים',
    scopeAll: 'כל האינטרנט',
    scopeSearch: 'חיפוש באינטרנט', // web/service.ts SEARCH_SCOPE_HOST
    scopeUntil: 'בתוקף עד',
    scopeNoLimit: 'ללא הגבלת זמן (היקף ליצירה)',
    scopePurpose: 'מטרה',
    // 20: מייל
    scopeRecipients: 'שליחה אל',
    scopeAllRecipients: 'כל נמען',
    scopeMailbox: 'קריאה מתיבת המייל שלך',
    scopeSince: 'מאז',
    mailTo: 'אל',
    mailCc: 'העתק',
    mailSubject: 'נושא',
    mailText: 'תחילת הטקסט',
    mailFiles: 'קבצים מצורפים',
    fault: 'תקלה: לא אושר ולא נדחה. נסה שוב.',
    result: (approved: number, executed: number) => `אושרו ${approved.toLocaleString('he-IL')}, בוצעו ${executed.toLocaleString('he-IL')}.`,
    itemStatus: { pending: 'ממתין', approved: 'אושר', rejected: 'נדחה', executed: 'בוצע', failed: 'נכשל' } as Record<string, string>,
  },
  iface: {
    tab: 'ממשקים',
    hint: 'רק הממשקים שהקוד של היצירה משתמש בהם. כש-side-effect: "באישור" מחכה ללחיצה של אדם לפני ביצוע; "אוטומטי" מבצע מיד ונרשם בלוג.',
    none: 'היצירה הזו לא משתמשת בשום ממשק. היא רצה על הנתונים שכבר נטענו ולא קוראת לבינה או למערכת חיצונית.',
    auto: 'אוטומטי',
    consent: 'באישור',
    readOnly: 'קריאה בלבד, בלי אישור',
    saved: 'נשמר',
    scopeHosts: 'אתרים בקוד',
    scopeNone: 'הקוד לא מצהיר על אתרים',
    scopeStatus: { approved: 'מאושר', pending: 'ממתין לאישור', missing: 'לא אושר', none: '' } as Record<string, string>,
    approveScope: 'אשר גישה',
    revokeScope: 'בטל גישה',
    // 20: mail.send
    scopeRecipients: 'נמענים בקוד',
    scopeNoRecipients: 'הקוד לא מצהיר על נמענים',
    mailConsent: 'שאל לפני כל שליחה',
    mailAuto: 'שלח בלי לשאול',
  },
  // 20 §1.2: "חיבור Gmail" — drawer זמני (כמו קונסנט): נפתח כשאייבי/יצירה צריכים Gmail, ומהתפריט
  // platform-push-notifications
  push: {
    nav: 'התראות',
    title: 'התראות',
    close: 'סגור',
    intro: 'התראה למכשיר הזה כשמשהו מחכה לך, גם כשהמסך סגור.',
    privacy: 'בהתראה עצמה אין שמות ואין נתונים, רק מה קרה וקישור.',
    on: 'פעיל במכשיר הזה',
    off: 'כבוי במכשיר הזה',
    enable: 'הפעל התראות במכשיר הזה',
    disable: 'כבה במכשיר הזה',
    test: 'שלח התראת בדיקה',
    testSent: 'נשלחה. אם לא הגיעה, בדוק שההתראות מותרות לאתר בהגדרות הדפדפן ובמערכת.',
    devices: (n: number) => (n === 1 ? 'מכשיר אחד מקבל התראות' : `${n} מכשירים מקבלים התראות`),
    kindsTitle: 'על מה להתריע',
    kinds: {
      turn: 'אייבי או מנהל הבינה סיימו לעבוד',
      consent: 'אישור שמחכה לך',
      request: 'בקשות למנהל הבינה',
      trigger: 'תזמון שלא הצליח לרוץ',
      share: 'שיתפו איתך יצירה',
    } as Record<string, string>,
    unsupported: 'הדפדפן הזה לא תומך בהתראות.',
    ios: 'באייפון: פתח את האתר בספארי, לחץ "שיתוף" ← "הוסף למסך הבית", ופתח את האפליקציה משם. ההתראות זמינות רק משם.',
    denied: 'ההתראות חסומות לאתר הזה בדפדפן. אפשר לפתוח אותן בהגדרות האתר (סמל המנעול ליד הכתובת) ואז לחזור לכאן.',
    deniedNow: 'לא אישרת התראות בדפדפן, אז לא הופעלו.',
    disabled: 'ההתראות עוד לא הוגדרו במערכת.',
    failed: 'ההפעלה לא הצליחה. נסה שוב בעוד רגע.',
  },
  mail: {
    nav: 'חיבור Gmail',
    title: 'חיבור Gmail',
    close: 'סגור',
    need: { send: 'כדי לשלוח את המייל, צריך לחבר את ה-Gmail שלך.', read: 'כדי לקרוא מהתיבה שלך, צריך לחבר את ה-Gmail שלך.' } as Record<string, string>,
    needBoth: 'כדי לשלוח ולקרוא מייל, צריך לחבר את ה-Gmail שלך.',
    intro: 'אייבי ויצירות ישלחו מיילים מה-Gmail שלך.',
    reauth: 'Google ניתקה את החיבור. צריך להתחבר שוב.',
    // 21 §2: מה מאשרים בדיוק + קישור למדיניות הפרטיות (גוגל דורשת, במגירת החיבור)
    consentNote: 'aibify ישלח מיילים מהתיבה שלך רק כשתאשר או לנמענים שאישרת. לא קוראים את התיבה.',
    consentNoteRead: 'aibify ישלח מיילים מהתיבה שלך רק כשתאשר או לנמענים שאישרת, ויקרא מהתיבה רק באישורך.',
    privacy: 'מדיניות הפרטיות',
    privacyUrl: 'https://aibify.com/privacy',
    readOff: 'קריאת מיילים עוד לא זמינה כאן. אפשר לחבר לשליחה בלבד.',
    google: 'התחבר עם Google',
    waiting: 'ממשיכים בחלון של Google…',
    noWindow: 'החלון לא נפתח?',
    sameTab: 'המשך כאן',
    cancel: 'ביטול',
    done: 'מחובר',
    resuming: 'ממשיכים מאיפה שעצרנו…',
    retry: 'אפשר לנסות שוב.',
    notConfigured: 'חיבור Gmail לא מוגדר בשרת הזה. פנה למנהל המערכת.',
    caps: { send: 'שליחה', read: 'קריאה' } as Record<string, string>,
    connectedFor: (caps: string) => `מחובר ל${caps}`,
    add: { send: 'הוסף שליחה', read: 'הוסף קריאה' } as Record<string, string>,
    status: { ok: 'פעיל', reauth_required: 'צריך להתחבר שוב', error: 'תקלה' } as Record<string, string>,
    disconnect: 'נתק',
    disconnecting: 'מנתק…',
    disconnected: 'Gmail נותק.',
    error: (code: string) => (code === 'access_denied' ? 'לא אישרת אצל Google. אפשר לנסות שוב.' : 'החיבור לא הצליח. נסה שוב.'),
    popupDone: 'Gmail מחובר. אפשר לסגור את החלון.',
    popupError: 'החיבור לא הצליח. אפשר לסגור את החלון ולנסות שוב.',
    connect: 'חבר Gmail',
    needCard: 'צריך לחבר Gmail',
    connectedCard: 'Gmail מחובר',
  },
  /** 19 §1.5: לשונית "תזמונים" ביצירה. */
  triggers: {
    tab: 'תזמונים',
    hint: 'היצירה תרוץ לבד בזמן קבוע, בשמך. ריצה מתוזמנת לא יכולה לחכות לאישור, אז ממשקים עם תופעת לוואי צריכים להיות "בלי אישור".',
    none: 'אין תזמונים ליצירה הזו.',
    newTitle: 'תזמון חדש',
    name: 'שם התזמון',
    when: 'מתי',
    presets: { daily: 'כל יום', workdays: 'ימי עבודה (א–ה)', weekly: 'שבועי', monthly: 'חודשי', advanced: 'מתקדם (cron)' } as Record<string, string>,
    time: 'שעה',
    weekday: 'יום בשבוע',
    days: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
    dom: 'יום בחודש',
    cron: 'ביטוי cron (דקה שעה יום חודש יום-בשבוע, שעון ישראל)',
    save: 'שמירת תזמון',
    saving: 'שומר…',
    saved: 'התזמון נשמר',
    next: 'הפעלה הבאה',
    last: 'הפעלה אחרונה',
    never: 'עוד לא רץ',
    active: 'פעיל',
    paused: 'מושהה',
    off: 'כבוי',
    runNow: 'הרץ עכשיו',
    remove: 'מחק',
    confirmRemove: (n: string) => `למחוק את התזמון «${n}»?`,
    toInterfaces: 'ללשונית ממשקים',
    by: (n: string) => `של ${n}`,
    scheduled: 'מתוזמן',
    fromTrigger: 'מתזמן',
    /** triggers-failure-notify-retry: הניסיון החוזר של מועד שנכשל. */
    secondAttempt: 'ניסיון שני',
    firedBy: (n: string) => `הופעל מתזמון «${n}»`,
    alertsTitle: 'תזמונים',
  },
  theme: { label: 'ערכת צבע', system: 'לפי המערכת', light: 'בהירה', dark: 'כהה' },
  notFound: 'הדף לא נמצא',
} as const;
